import { combineReducers, configureStore } from "@reduxjs/toolkit";
import uiSlice from "./uiSlice";
import authSlice from "./authSlice";
import vendorSlice from "./vendorSlice";
import categorySlice from "./categorySlice";
import sliderSlice from "./sliderSlice";
import areaSlice from "./areaSlice";
import userSlice from "./userSlice";
import productSlice from "./productSlice";
import orderSlice from "./orderSlice";
import complainSlice from "./complainSlice";
import vendorCategorySlice from "./vendorCategories";
import citySlice from "./citySlice";
import bannerSlice from "./bannerSlice";
import optionSlice from "./optionSlice";
import deliveryOrderSlice from "./delvieryOrderSlice";

const combinedReducer = combineReducers({
    ui: uiSlice.reducer,
    auth: authSlice.reducer,
    vendor: vendorSlice.reducer,
    category: categorySlice.reducer,
    option: optionSlice.reducer,
    slider: sliderSlice.reducer,
    banner: bannerSlice.reducer,
    area: areaSlice.reducer,
    city: citySlice.reducer,
    user: userSlice.reducer,
    product: productSlice.reducer,
    order: orderSlice.reducer,
    deliveryOrder: deliveryOrderSlice.reducer,
    complain: complainSlice.reducer,
    vendorCategory: vendorCategorySlice.reducer,
});

const rootReducer = (state, action) => {
    if (action.type === "auth/logout") {
        state = undefined;
    }
    return combinedReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
});

export default store;
